import React from 'react';
import OperationsInfoTip from './OperationsInfoTip';

export function OpsChartTitle({ title, infoKey }: { title: string; infoKey?: string }) {
  return (
    <div className="mb-4 flex items-center gap-2">
      <p className="text-sm font-semibold text-gray-900 dark:text-white">{title}</p>
      {infoKey && <OperationsInfoTip metricKey={infoKey} title={title} />}
    </div>
  );
}

export function OpsTableHeader({ label, columnKey }: { label: string; columnKey?: string }) {
  return (
    <span className="inline-flex items-center gap-1.5">
      {label}
      {columnKey && <OperationsInfoTip columnKey={columnKey} title={label} />}
    </span>
  );
}

export function OpsStatLabel({ label, infoKey }: { label: string; infoKey?: string }) {
  return (
    <div className="flex items-center gap-1.5">
      <p className="text-xs font-medium uppercase tracking-wide text-gray-400 dark:text-gray-500">{label}</p>
      {infoKey && <OperationsInfoTip metricKey={infoKey} title={label} />}
    </div>
  );
}

export function OpsStatusBadge({
  status,
  showInfo = true,
}: {
  status: string;
  showInfo?: boolean;
}) {
  const statusInfoKey =
    status === 'healthy'
      ? 'statusHealthy'
      : status === 'warning'
        ? 'statusWarning'
        : status === 'critical' || status === 'down'
          ? 'statusCritical'
          : 'statusUnknown';

  return (
    <span className="inline-flex items-center gap-1.5 capitalize">
      {status}
      {showInfo && <OperationsInfoTip metricKey={statusInfoKey} title={`Status: ${status}`} />}
    </span>
  );
}
